// Base Angular environment — runtime values (sosUrl, intercomAppId, envName, etc.)
// are now served by GET /api/config via RuntimeConfigService (AH-6807).
// Only local dev flags remain here for local/test build configurations.

const env_config = {
    production: false,
    development: false,
    staging: false,
    local: false,
    local80: false,
    test: false,
    sentryDebug: false,
};

export default env_config;
